import {ReactComponent as DashboardIcon} from "../../Assets/Icons/Layout.svg"
import {ReactComponent as DatasourceIcon} from "../../Assets/Icons/Server.svg"
import {ReactComponent as GoalsIcon} from "../../Assets/Icons/Lightning.svg"
import {ReactComponent as LogoutIcon} from "../../Assets/Icons/Logout.svg"
import {ReactComponent as CategoryIcon} from "../../Assets/Icons/Stack.svg"
import {ReactComponent as Crossicon} from "../../Assets/Icons/Cross.svg"
import { AuthContext, useLogout} from '../../Contexts/Authprovider';
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "./SideBar.scss"
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify"
import { useContext } from "react"

var sidebarNavItems = [
]

export default function SideBar() {
  const { user } = useContext(AuthContext);
  const Dashboard =   {
    display: 'Dashboard',
    icon: <DashboardIcon/>,
    to: '/',
    section: ''
}
const Datasources =   {
  display: 'Datasources',
  icon: <DatasourceIcon/>,
  to: '/Datasources',
  section: 'Datasources'
}
const Goals =   {
  display: 'Goals',
  icon: <GoalsIcon/>,
  to: '/Goals',
  section: 'Goals'
}
const Templates = {
  display: 'Templates',
  icon: <CategoryIcon/>,
  to: '/Templates',
  section: 'Templates'
}
  useEffect(() => {
    if(user){
      sidebarNavItems = []
      sidebarNavItems.push(Dashboard)
      if(user.role.rolename === "director"){
        sidebarNavItems.push(Goals)
        sidebarNavItems.push(Templates)
      }
      if(user.role.rolename === "externaluser"){
        // add what externaluser can see
        sidebarNavItems.push(Goals)
      }
      if(user.role.rolename === "economicmanager"){
        // add what economicmanager can see
        sidebarNavItems.push(Templates)
        sidebarNavItems.push(Goals)
        sidebarNavItems.push(Datasources)
      }
      if(user.role.rolename === "ecologicalmanager"){
        // add what ecologicalmanager can see
        sidebarNavItems.push(Templates)
        sidebarNavItems.push(Goals)
        sidebarNavItems.push(Datasources)
      }
      if(user.role.rolename === "socialmanager"){
        // add what socialmanager can see
        sidebarNavItems.push(Templates)
        sidebarNavItems.push(Goals)
        sidebarNavItems.push(Datasources)
      }
      if(user.role.rolename === "MVOCoordinator"){
        // add what mvocoordinator can see
        sidebarNavItems.push(Goals)
        sidebarNavItems.push(Templates)
      }
    }
  },[user])
  const history = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [stepHeight, setStepHeight] = useState(0);
  const sidebarRef = useRef();
  const indicatorRef = useRef();
  const location = useLocation();
  const logout = useLogout();

  //bepaalt hoogte van NavItem
  useEffect(() => {
    setTimeout(() => {
        const sidebarItem = sidebarRef.current.querySelector('.NavItem');
        indicatorRef.current.style.height = `${sidebarItem.clientHeight}px`;
        setStepHeight(sidebarItem.clientHeight);
    }, 50);
  }, [sidebarNavItems]);

  // Verandert de huidige index naar de index van de categorie
  useEffect(() => {
    const curPath = window.location.pathname.split('/')[1];
    const activeItem = sidebarNavItems.findIndex(item => item.section === curPath);
    setActiveIndex(curPath.length === 0 ? 0 : activeItem);
  }, [location]);

  //Delay
  function timeout(delay) {
      return new Promise( res => setTimeout(res, delay) );
  }

  //Voegt animatie classes toe aan de elementen
  async function NavigateLogin(){
    logout();
    toast.success("Signed out successfully!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      });
    document.getElementsByClassName('container')[0].classList.add("animateSidebar")
    document.getElementsByClassName('HeaderContainer')[0].classList.add("animateHeader")
    try{
      document.getElementsByClassName('HomeContainer')[0].classList.add("animateDashboard")
    }catch(e)
    {}
    try{
      document.getElementsByClassName('DataContainer')[0].classList.add("animateDashboard")
    }catch(e)
    {}
    try{
      document.getElementsByClassName('GoalsContainer')[0].classList.add("animateDashboard")
    }catch(e)
    {}
    try{
      document.getElementsByClassName('CategoriesContainer')[0].classList.add("animateDashboard")
    }catch(e)
    {}
    try{
      document.getElementsByClassName('CategoriesContainer')[0].classList.add("animateDashboard")
    }catch(e)
    {
      
    }
    await timeout(500)
    history("/login")
  }
  function closeMenu(){
      document.getElementsByClassName('container')[0].classList.add("animateSidebarOut")
      document.getElementsByClassName('container')[0].classList.remove("animateSidebarIn")
  }
  return (
    <div className='container' required data-cy="sidebar">
      <div onClick={closeMenu} className="NavBtn">
        <Crossicon/>
      </div>
            <div
        ref={indicatorRef}
        className="highlight"
        style={{
            transform: `translateX(-50%) translateY(${activeIndex * (stepHeight+10)}px)`
            }}></div>
      <nav>
        <ul ref={sidebarRef}>
          {sidebarNavItems.map((item, index) => (
            <NavLink key={index} to={item.to} className={`NavItem ${activeIndex === index ? 'active' : ''}` + item.display} required data-cy={`Nav${index}`}>
            {item.icon}
            <p>{item.display}</p>
          </NavLink>
          ))}
        </ul>
      </nav>
      <div onClick={NavigateLogin} className="NavItem signout" required data-cy="log_out">
        <LogoutIcon/>
        <p>Sign Out</p>
      </div>
    </div>
  )
}